<template>
    <div class="h-100">
            <grid
                ref="grid"
                v-if="settings.feed_enabled && rowData.length > 0"
                :columnDefs="columnDefs"
                :rowData="rowData"
                grid-theme="ag-theme-alpine-partner"
                row-selection="multiple"
                :suppress-row-click-selection="true"
                :header-height="50"
                @selection-changed="handleSelectionChange"
                :is-auto-width="true"
            >
                <responsive-button
                    v-if="!hasSelectedRows"
                    variant="primary"
                    :icon="['fas', 'file-contract']"
                    href="/app/policy/cancellation-policy/list/"
                    target="_blank"
                >
                    Custom Cancellation Policies
                </responsive-button>
                <responsive-button
                    v-if="settings.feed_enabled && !hasSelectedRows"
                    variant="primary"
                    :disabled="!selfBoardingLink"
                    :href="selfBoardingLink"
                    :icon="['fas', 'book']"
                    target="_blank"
                    >Self Service Onboarding</responsive-button
                >
                <!-- <responsive-button
                    v-if="showPricingPolicy && !hasSelectedRows"
                    @click="openPriceConsistencyModal"
                    variant="primary"
                    :icon="['fas', 'money-check-dollar']"
                >
                    Set Price Consistency (All)
                </responsive-button> -->
                <responsive-button
                    v-if="settings.feed_enabled && !hasSelectedRows"
                    :icon="['fas', 'gear']"
                    @click="handleSettingsClick"
                    variant="primary"
                    >Settings</responsive-button
                >
                <responsive-button
                    v-if="settings.feed_enabled && !hasSelectedRows"
                    @click="refreshFeed"
                    variant="primary"
                    :icon="['fas', 'arrows-rotate']"
                >
                    Refresh
                </responsive-button>
                <bulk-actions
                    v-if="hasSelectedRows"
                    :selected-count="currentSelectedRows.length"
                    :bulk-action-defs="bulkActionDefs"
                />
                <span v-if="!hasSelectedRows" class="d-none d-sm-flex">
                    <form-square-switch
                        :labels="{
                            checked: 'Feed On',
                            unchecked: 'Feed Off',
                        }"
                        :value="settings.feed_enabled"
                        @change="onChangeFeedEnabled"
                        class="toggle-feed"
                        :isToolbar="true"
                        :sync="true"
                        :disabled="!userHasCCGateway"
                /></span>
                <b-button-group v-if="!hasSelectedRows" class="d-sm-none d-flex">
                    <more-filters-dropdown class="vrbo-dropdown">
                        <form-square-switch
                            v-if="!hasSelectedRows"
                            :labels="{
                                checked: 'Feed On',
                                unchecked: 'Feed Off',
                            }"
                            :value="settings.feed_enabled"
                            @change="onChangeFeedEnabled"
                            class="toggle-feed mr-1 w-100"
                            :isToolbar="true"
                            :sync="true"
                            :disabled="!userHasCCGateway"
                        />
                    </more-filters-dropdown>
                </b-button-group>
            </grid>
            <div v-else-if="!busy && allowVRBO" class="p-1">
                <div class="d-flex">
                    <responsive-button
                        :icon="['fas', 'circle-info']"
                        variant="primary"
                        @click="showInfoModal"
                    ></responsive-button>
                    <form-square-switch
                        :labels="{
                            checked: 'Feed On',
                            unchecked: 'Feed Off',
                        }"
                        :value="settings.feed_enabled"
                        @change="onChangeFeedEnabled"
                        class="toggle-feed mr-1"
                        :isToolbar="true"
                        :sync="true"
                        :disabled="!userHasCCGateway"
                    />
                    <responsive-button
                        variant="primary"
                        :icon="['fas', 'file-contract']"
                        href="/app/policy/cancellation-policy/list/"
                        target="_blank"
                    >
                        Cancellation Policies
                    </responsive-button>
                </div>
                <div class="pt-2" v-if="!isLoading && !userHasCCGateway">
                    <span class="text-danger">
                        A
                        <a class="text-danger vrbo-payment-gateway-link" href="/app/payment-gateway/setup/">payment gateway</a>
                        is required to enable the VRBO connection.
                    </span>
                </div>
            </div>

        <b-col v-if="!allowVRBO && allowVRBORequest" class="mt-1">
            <b-row v-if="!userHasCCGateway">
                <b-col cols="5">
                    <span class="text-danger">
                        A
                        <a class="text-danger vrbo-payment-gateway-link" href="/app/payment-gateway/setup/">payment gateway</a>
                        is required to enable the VRBO connection.
                    </span>
                </b-col>
            </b-row>
            <b-row class="mt-3 mt-1">
                <b-col sm="12" md="5">
                     In addition to any VRBO host fees, Lodgix will charge 0.5% on all bookings (rental charges only) originating from VRBO.
                     This billing is done once per month, and assessed on any VRBO bookings that were completed in the previous month.
                     Most will pass all host fees through to the guest using a rate multiplier. 
                </b-col>
            </b-row>
            <b-row class="mt-3">
                <b-col>
                    <responsive-button
                        :icon="['fas', 'right-to-bracket']"
                        :responsiveness="false"
                        @click="handleRequestVRBOAccessClick"
                        variant="primary"
                        :disabled="!userHasCCGateway || allowVRBO"
                        >Request VRBO Publish Access</responsive-button
                    >
                </b-col>
            </b-row>
        </b-col>
        <b-col v-if="!allowVRBO && !allowVRBORequest && !busy" class="mt-1">
            <b-row class="mt-3 mt-1">
                <b-col sm="12" md="5">
                     VRBO Publish Request sent. Please come back later to see if your request has been approved.
                </b-col>
            </b-row>
        </b-col>               
        <modal title="VRBO Integration" :id="infoModalId">
            <a
                class="d-block text-primary mb-4"
                target="_blank"
                href="https://support.lodgix.com/en/articles/3323781-homeaway-vrbo-integration"
                >VRBO INTEGRATION DOCUMENTATION(IMPORTANT!)</a
            >
            <b-alert show variant="info">
                In addition to any VRBO host fees, Lodgix will charge 0.5% on
                all bookings (rental charges only) originating from VRBO. This
                billing is done once per month, and assessed on any VRBO
                bookings that were completed in the previous month. Most will
                pass all host fees through to the guest using a rate multiplier.
            </b-alert>
        </modal>
        <settings-modal-form
            :key="settingsModalKey"
            :partnerSettings="settings"
            :modalId="settingsModalId"
            @updated="updateSettings"
            @hidden="hiddenSettings"
        />
        <modal
            ok-title="Confirm"
            @ok="setPriceConsistency"
            :id="priceConsistencyModalId"
            title="Set Price Consistency"
        >
            Are you sure you want to set Price Consistency for all properties?
        </modal>
        <registration-modal
            :registrationStatusModalId="registrationStatusModalId"
            :feedShare="currentFeedShare"
            :feedShareNode="currentFeedShareNode"
            @hidden="hiddenRegistrationModal"
        />
        <modal
            :id="statusModalId"
            title="Status"
            ok-only
        >
            <div
                v-for="(checkpoint, index) in (currentFeedShare && currentFeedShare.unfulfilled_status_checkpoints) || []"
                class="mb-2 mt-2"
            >
                <hr v-if="index !== 0" />
                <div class="d-flex align-items-center">
                    <font-awesome-icon
                        :icon="['fas', 'circle-xmark']"
                        class="text-danger"
                    ></font-awesome-icon>
                    <div class="ml-3">
                        {{ checkpoint }}
                    </div>
                </div>
            </div>
        </modal>
        <modal
            :id="requestVRBOAccessModalId"
            title="Request VRBO Publish Access"
            ok-title="Request Access"
            @ok="requestVRBOAccess"
            :ok-disabled="busy"
        >
            <span
                >Requesting access is required to publish properties to VRBO. Click the "Request Access" button below
                and someone from Lodgix will review your request. Please come back later to see if your request has been
                approved.</span
            >
        </modal>        
    </div>
</template>

<script>
import isNil from 'lodash/isNil';
import API from '../../../api';
import { toAmountDisplay } from '../../../utils/numbers';
import {
    PARTNER_VRBO_SETTINGS_ENDPOINT,
    PARTNER_VRBO_SHARE_FEED_ENDPOINT,
    CANCELLATION_POLICY_TEMPLATE_ENDPOINT,
    PARTNER_VRBO_SHARE_FEED_UPDATE_CANCELLATION_POLICY_ENDPOINT,
    PARTNER_VRBO_SHARE_FEED_UPDATE_RATE_POLICY_ENDPOINT,
    PARTNER_VRBO_SHARE_FEED_UPDATE_USE_MARKETING_TITLE_ENDPOINT,
    PARTNER_VRBO_SHARE_FEED_UPDATE_ENABLED_ENPOINT,
    PARTNER_VRBO_SHARE_FEED_RESYNC_ENDPOINT,
    PARTNER_VRBO_FEED_ENABLED_ENDPOINT,
    PARTNER_VRBO_FEED_SHARE_BULK_MARKETING_TITLE_ENABLE,
    PARTNER_VRBO_FEED_SHARE_BULK_MARKETING_TITLE_DISABLE,
    PARTNER_VRBO_FEED_SHARE_BULK_PROPERTY_ENABLE,
    PARTNER_VRBO_FEED_SHARE_BULK_PROPERTY_DISABLE,
    PARTNER_VRBO_SET_PRICE_CONSISTENCY,
    PARTNER_VRBO_REQUEST_ACCESS_ENDPOINT,
    PARTNER_VRBO_DATA_ENDPOINT,
} from '../../../endpoints';
import FormSquareSwitch from '../../generic/form-square-switch/form-square-switch.vue';
import Grid from '../../generic/grid/grid.vue';
import Modal from '../../generic/modal/modal.vue';
import ResponsiveButton from '../../generic/responsive-button/responsive-button.vue';
import BusyModal from '../../generic/busy-modal/busy-modal.vue';
import SettingsModalForm from './settings-modal-form.vue';
import { escapeHTML } from '../../../utils/strings';
import { formatResponseError } from '../../../utils/api';
import RegistrationModal from './registration-modal.vue';
import { removeScrollMixin } from '../../../mixins/remove-scroll-mixin';
import { mapGetters } from 'vuex';
import { isMediumScreen } from '../../../utils/screens';
import BulkActions from '../../generic/bulk-actions/bulk-actions.vue';
import MoreFiltersDropdown from '../../generic/more-filters-dropdown/more-filters-dropdown.vue';
import ActionsCellRenderer from './vrbo-actions-cell-renderer.vue';
import StatusCellRenderer from './status-cell-renderer.vue';
import RegistrationStatusCellRenderer from './registration-status-cell-renderer.vue';

const defaultCancellationPolicies = [
    { value: 'NO_REFUND', text: 'No Refund' },
    { value: 'STRICT', text: 'Strict' },
    { value: 'RELAXED', text: 'Relaxed' },
    { value: 'MODERATE', text: 'Moderate' },
    { value: 'FIRM', text: 'Firm' },
];

export default {
    name: 'PartnerVRBO',
    components: {
        Grid,
        FormSquareSwitch,
        ResponsiveButton,
        Modal,
        BusyModal,
        SettingsModalForm,
        RegistrationModal,
        BulkActions,
        MoreFiltersDropdown,
        actionsCellRenderer: ActionsCellRenderer,
        statusCellRenderer: StatusCellRenderer,
        registrationStatusCellRenderer: RegistrationStatusCellRenderer,
    },
    mounted() {
        this.load();
    },
    mixins: [removeScrollMixin],
    data() {
        return {
            allowVRBO: false,
            allowVRBORequest: false,
            busy: false,
            rowData: [],
            cancellationPoliciesVRBO: [...defaultCancellationPolicies],
            customPolicies: [],
            infoModalId: 'vrbo-integration-info',
            settings: {
                feed_enabled: null,
            },
            settingsModalId: 'vrbo-settings-modal',
            settingsModalKey: 100,
            statusModalId: 'vrbo-status-modal',
            registrationStatusModalId: 'vrbo-registration-modal',
            currentFeedShare: null,
            currentFeedShareNode: null,
            currentSelectedRows: [],
            bulkActionDefs: [
                {
                    label: 'Enable',
                    group: 'Marketing Title',
                    onClick: this.handleMarketingTitleBulkEnable,
                },
                {
                    label: 'Disable',
                    group: 'Marketing Title',
                    onClick: this.handleMarketingTitleBulkDisable,
                },
                {
                    label: 'Enable',
                    group: 'Property',
                    onClick: this.handleEnabledbulkPropertyEnable,
                },
                {
                    label: 'Disable',
                    group: 'Property',
                    onClick: this.handleEnabledbulkPropertyDisable,
                },
            ],
            priceConsistencyModalId: 'price-consistency-modal-id',
            requestVRBOAccessModalId: 'request-vrbo-access-modal',
        };
    },
    computed: {
        ...mapGetters('header', ['userHasCCGateway', 'isLoading']),
        isMobile() {
            const md = 768;
            return window.innerWidth < md || window.innerHeight < md;
        },
        columnDefs() {
            return [
                {
                    field: 'rental_property.id',
                    headerName: 'P. ID',
                    minWidth: 60,
                    pinned: 'left',
                    headerCheckboxSelection: true,
                    headerCheckboxSelectionFilteredOnly: true,
                    checkboxSelection: true,
                },
                {
                    field: 'rental_property.name',
                    headerName: 'P. Name',
                    suppressSizeToFit: true,
                    pinned: 'left',
                    minWidth: 80,
                    width: isMediumScreen() ? undefined : 80,
                    autoWidthExclude: this.isMobile,
                    cellRenderer: ({ data }) => {
                        const name = data.rental_property.name;

                        if (data.remote_id != null && data.subpartner != null) {
                            if (data.subpartner == 'VRBO') {
                                return (
                                    '<a target=_blank href="http://www.vrbo.com/' +
                                    data.remote_id +
                                    '">' +
                                    escapeHTML(name) +
                                    '</a>'
                                );
                            } else {
                                return (
                                    '<a target=_blank href="http://www.vrbo.com/' +
                                    data.remote_id +
                                    'ha">' +
                                    escapeHTML(name) +
                                    '</a>'
                                );
                            }
                        }
                        return escapeHTML(name);
                    },
                },
                {
                    field: 'cancellation_policy',
                    headerName: 'Cancellation Policy',
                    cellEditor: 'selectCellEditor',
                    editable: true,
                    cellEditorParams: () => ({
                        options: this.cancellationPoliciesVRBO,
                    }),
                    valueGetter: ({ data }) => {
                        return this.getSelectPolicyValues(data, 'value') || 'Not Set';
                    },
                    cellRenderer: ({ data }) => {
                        return this.getSelectPolicyValues(data, 'text') || 'Not Set';
                    },
                    cellClass: 'text-primary lx-editable-cell',
                    valueSetter: async ({ node, data, newValue, oldValue }) => {
                        const oldCancellationPolicy = data.cancellation_policy;
                        (async () => {
                            const body = {};
                            if (typeof newValue === 'number') {
                                body.cancellation_policy = 'CUSTOM';
                                body.custom_cancellation_policy_id = newValue;
                            } else {
                                body.cancellation_policy = newValue;
                                body.custom_cancellation_policy_id = null;
                            }
                            try {
                                const feedShare = await API.put(
                                    PARTNER_VRBO_SHARE_FEED_UPDATE_CANCELLATION_POLICY_ENDPOINT(data.id),
                                    body
                                );
                                node.setData(feedShare.data);
                            } catch (e) {
                                this.errorToast({
                                    text: 'Could not save cancellation policy',
                                });
                                data.cancellation_policy = oldCancellationPolicy;
                                node.setData(data);
                            }
                        })();
                        if (typeof newValue === 'number') {
                            data.cancellation_policy = 'CUSTOM';
                            data.custom_cancellation_policy_id = newValue;
                        } else {
                            data.cancellation_policy = newValue;
                            data.custom_cancellation_policy_id = null;
                        }

                        return true;
                    },
                },
                {
                    field: 'rate_multiplier',
                    headerName: 'Rate Multiplier',
                    type: 'editableColumn',
                    cellClass: 'lx-editable-cell text-primary d-flex justify-content-center',
                    headerClass: 'ag-centered-header',
                    valueGetter: ({ data }) => data.rate_multiplier,
                    cellEditorParams: ({ data, columnApi }) => ({
                        isDecimal: true,
                        select: true,
                        empty: false,
                        emptyValue: null,
                        maxDecimalPlaces: 4,
                        maxNumber: 20000,
                    }),
                    cellRenderer: ({ value }) => {
                        if (isNil(value)) {
                            return 'Not set';
                        }
                        return toAmountDisplay({
                            amount: value,
                            decimalPlaces: 4,
                        });
                    },
                    valueSetter: async ({ node, data, newValue, oldValue }) => {
                        (async () => {
                            try {
                                await API.put(PARTNER_VRBO_SHARE_FEED_UPDATE_RATE_POLICY_ENDPOINT(data.id), {
                                    rate_multiplier: Number(newValue),
                                });
                            } catch (e) {
                                const { generic } = formatResponseError(e);
                                this.errorToast({
                                    text: generic || 'Could not save rate.',
                                });
                                data.rate_multiplier = oldValue;
                                node.setData(data);
                            }
                        })();
                        data.rate_multiplier = newValue;
                        return true;
                    },
                },
                {
                    field: 'use_marketing_title',
                    headerName: 'Marketing Title',
                    type: 'switchColumn',
                    cellClass: 'd-flex justify-content-center',
                    headerClass: 'ag-centered-header',
                    cellRendererParams: {
                        onChange: async ({ data, node, api }, value) => {
                            try {
                                await API.put(PARTNER_VRBO_SHARE_FEED_UPDATE_USE_MARKETING_TITLE_ENDPOINT(data.id), {
                                    use_marketing_title: value,
                                });
                            } catch (e) {
                                this.errorToast({
                                    text: `Could not save`,
                                });
                                api.redrawRows({
                                    rowNodes: [node],
                                });
                                return;
                            }
                        },
                    },
                },
                {
                    field: 'gp_status',
                    headerName: 'PC Status',
                    cellRenderer: ({ data }) => data.gp_status.join(', '),
                },
                {
                    field: 'registration_status',
                    headerName: 'Registration Status',
                    cellRenderer: 'registrationStatusCellRenderer',
                    cellRendererParams: {
                        onRegistrationStatusClick: this.handleVrboRegistrationStatusClick,
                    },
                },
                {
                    field: 'serving_status',
                    headerName: 'Status',
                    cellRenderer: 'statusCellRenderer',
                    cellRenderer: 'statusCellRenderer',
                    cellRendererParams: {
                        onStatusClick: this.handleVrboStatusClick,
                    },
                },
                {
                    field: 'enabled',
                    headerName: 'Enabled',
                    type: 'switchColumn',
                    resizable: false,
                    cellRendererParams: {
                        onChange: async ({ data, node, api }, value) => {
                            try {
                                const { data: feedShare } = await API.put(
                                    PARTNER_VRBO_SHARE_FEED_UPDATE_ENABLED_ENPOINT(data.id),
                                    {
                                        enabled: value,
                                    }
                                );
                                node.setData(feedShare);
                            } catch (e) {
                                this.errorToast({
                                    text: `Could not save`,
                                });
                                api.redrawRows({
                                    rowNodes: [node],
                                });
                                return;
                            }
                        },
                    },
                },
                {
                    headerName: '',
                    maxWidth: 60,
                    minWidth: 60,
                    resizable: false,
                    sortable: false,
                    cellStyle: { textAlign: 'center' },
                    cellRenderer: 'actionsCellRenderer',
                    cellRendererParams: {
                        resync: async ({ feedShare, node }) => {
                            this.$parent.$emit('busy', true);
                            try {
                                const { data } = await API.post(PARTNER_VRBO_SHARE_FEED_RESYNC_ENDPOINT(feedShare.id));
                                this.successToast({
                                    text: 'The status and the URL were successfully retrieved from VRBO.',
                                });
                                node.setData(data);
                            } catch (error) {
                                const { generic } = formatResponseError(error);
                                this.errorToast({
                                    text: generic || `Could not retrieve data from VRBO.`,
                                });
                                return;
                            } finally {
                                this.$parent.$emit('busy', false);
                            }
                        },
                    },
                },
                {
                    field: '',
                    headerName: '',
                    autoWidthExclude: true,
                    sortable: false,
                },
            ];
        },
        selfBoardingLink() {
            return this.settings?.vrbo_self_boarding_link;
        },
        showPricingPolicy() {
            return this.settings?.show_pricing_policy;
        },
        hasSelectedRows() {
            return this.currentSelectedRows.length > 0;
        },
    },
    methods: {
        async fetchData() {
            try {
                const { data } = await API.get(PARTNER_VRBO_DATA_ENDPOINT());
                this.allowVRBO = data.allow_vrbo;
                this.allowVRBORequest = data.allow_vrbo_request;
            } catch {
                this.errorToast({ text: 'Could not load VRBO data.' });
            }
        },
        async fetchSettings() {
            try {
                this.busy = true;
                const { data } = await API.get(PARTNER_VRBO_SETTINGS_ENDPOINT());
                this.settings = data;
                this.feedEnabled = data.feed_enabled;
            } catch (e) {
                const { generic } = formatResponseError(e);
                this.errorToast({ text: generic || 'Could not fetch settings.' });
            } finally {
                this.busy = false;
            }
        },
        async fetchFeedShare() {
            this.currentSelectedRows = [];

            try {
                this.busy = true;
                const { data } = await API.get(PARTNER_VRBO_SHARE_FEED_ENDPOINT());
                this.rowData = data;
            } catch (e) {
                const { generic } = formatResponseError(e);
                this.errorToast({ text: generic || 'Could not fetch feed.' });
            } finally {
                this.busy = false;
            }
        },
        async fetchCustomCancellationPolicies() {
            try {
                this.busy = true;
                const { data } = await API.get(CANCELLATION_POLICY_TEMPLATE_ENDPOINT());
                this.customPolicies = data;
                const customPolicies = data.map((item) => ({
                    text: item.name,
                    value: item.id,
                }));
                this.cancellationPoliciesVRBO = [...defaultCancellationPolicies, ...customPolicies];
            } catch (e) {
                this.errorToast({ text: 'Could not fetch custom policies' });
            } finally {
                this.busy = false;
            }
        },
        async requestVRBOAccess() {
            this.busy = true;
            this.$parent.$emit('busy', true);
            try {
                await API.post(PARTNER_VRBO_REQUEST_ACCESS_ENDPOINT());
                await this.load({ withBusy: false });
                this.$bvModal.hide(this.requestVRBOAccessModalId);
                this.successToast({ text: 'VRBO access request was sent.' });
            } catch (error) {
                const { generic } = formatResponseError(error);
                this.errorToast({
                    text: generic || 'Could not request nextpax access.',
                });
            } finally {
                this.busy = false;
                this.$parent.$emit('busy', false);
            }
        },
        async handleMarketingTitleBulkEnable() {
            this.$parent.$emit('busy', true);
            try {
                await API.post(PARTNER_VRBO_FEED_SHARE_BULK_MARKETING_TITLE_ENABLE(), {
                    feed_share_ids: this.currentSelectedRows.map((row) => row.id),
                });
                await this.fetchFeedShare();
            } catch (e) {
                this.errorToast({ text: 'Could not update marketing title.' });
            } finally {
                this.$parent.$emit('busy', false);
            }
        },
        async handleMarketingTitleBulkDisable() {
            this.$parent.$emit('busy', true);
            try {
                await API.post(PARTNER_VRBO_FEED_SHARE_BULK_MARKETING_TITLE_DISABLE(), {
                    feed_share_ids: this.currentSelectedRows.map((row) => row.id),
                });
                await this.fetchFeedShare();
            } catch (e) {
                this.errorToast({ text: 'Could not update marketing title.' });
            } finally {
                this.$parent.$emit('busy', false);
            }
        },
        async handleEnabledbulkPropertyEnable() {
            this.$parent.$emit('busy', true);
            try {
                await API.post(PARTNER_VRBO_FEED_SHARE_BULK_PROPERTY_ENABLE(), {
                    feed_share_ids: this.currentSelectedRows.map((row) => row.id),
                });
                await this.fetchFeedShare();
            } catch (e) {
                this.errorToast({ text: 'Could not enable property.' });
            } finally {
                this.$parent.$emit('busy', false);
            }
        },
        async handleEnabledbulkPropertyDisable() {
            this.$parent.$emit('busy', true);
            try {
                await API.post(PARTNER_VRBO_FEED_SHARE_BULK_PROPERTY_DISABLE(), {
                    feed_share_ids: this.currentSelectedRows.map((row) => row.id),
                });
                await this.fetchFeedShare();
            } catch (e) {
                this.errorToast({ text: 'Could not disable property.' });
            } finally {
                this.$parent.$emit('busy', false);
            }
        },
        handleSettingsClick() {
            this.$bvModal.show(this.settingsModalId);
        },
        handleVrboStatusClick(feedShare) {
            this.currentFeedShare = feedShare;
            this.$bvModal.show(this.statusModalId);
        },
        handleVrboRegistrationStatusClick(feedShare, node) {
            this.currentFeedShare = feedShare;
            this.currentFeedShareNode = node;
            this.$bvModal.show(this.registrationStatusModalId);
        },
        hiddenRegistrationModal() {
            this.currentFeedShare = null;
            this.currentFeedShareNode = null;
        },
        handleRequestVRBOAccessClick() {
            this.$bvModal.show(this.requestVRBOAccessModalId);
        },        
        async refreshFeed() {
            this.$parent.$emit('busy', true);
            try {
                await this.fetchFeedShare();
            } finally {
                this.$parent.$emit('busy', false);
            }
        },
        getSelectPolicyValues(data, key) {
            if (data.cancellation_policy === 'CUSTOM' && data.custom_cancellation_policy_id) {
                const cancellationItem = this.cancellationPoliciesVRBO.find(
                    (item) => item.value === data.custom_cancellation_policy_id
                );
                return (cancellationItem && cancellationItem[key]) || '';
            }
            const cancellationItem = this.cancellationPoliciesVRBO.find(
                (item) => item.value === data.cancellation_policy
            );
            return (cancellationItem && cancellationItem[key]) || '';
        },
        showInfoModal() {
            this.$bvModal.show(this.infoModalId);
        },
        async onChangeFeedEnabled({ value }) {
            try {
                this.settings.feed_enabled = value;
                await API.post(PARTNER_VRBO_FEED_ENABLED_ENDPOINT(), {
                    feed_enabled: value,
                });
                this.cancellationPoliciesVRBO = [...defaultCancellationPolicies];
                if (value) {
                    this.load();
                }
                this.successToast({
                    text: `Feed was ${value ? 'enabled' : 'disabled'} successfully`,
                });
            } catch (e) {
                this.settings.feed_enabled = !this.settings.feed_enabled;
                const { generic } = formatResponseError(e);
                this.errorToast({
                    text: generic || 'Could not enable feed.',
                });
            }
        },
        updateSettings(values) {
            this.successToast({
                text: 'Settings were successfully saved.',
            });
            this.settings = values;
        },
        hiddenSettings() {
            this.settingsModalKey++;
        },
        handleSelectionChange() {
            const gridApi = this.$refs.grid.gridOptions.api;
            this.currentSelectedRows = gridApi.getSelectedRows();
        },
        openPriceConsistencyModal() {
            this.$bvModal.show(this.priceConsistencyModalId);
        },
        async setPriceConsistency() {
            try {
                await API.post(PARTNER_VRBO_SET_PRICE_CONSISTENCY());
                this.successToast({
                    text: 'Price Consistency successfully set.',
                });
            } catch (e) {
                this.errorToast({ text: 'Could not set price consistency' });
            }
        },
        async load({ withBusy = true } = {}) {
            if (withBusy) {
                this.busy = true;
                this.$parent.$emit('busy', true);
            }
            try {
                await this.fetchData();
                await this.fetchSettings();

                if (this.settings.feed_enabled) {
                    await Promise.all([this.fetchFeedShare(), this.fetchCustomCancellationPolicies()]);
                }
            } finally {
                if (withBusy) {
                    this.busy = false;
                    this.$parent.$emit('busy', false);
                }
            }
        },
    },
};
</script>

<style scoped lang="scss">
.vrbo-dropdown {
    :deep(.buttons-wrapper) {
        width: 100%;
    }
}
.toggle-feed {
    width: 105px;
}
.vrbo-payment-gateway-link {
    text-decoration: underline;
}
</style>
